<ion-header>
	<ion-toolbar>
		<ion-title>Benutzername anlegen</ion-title>
	</ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
	<ion-text color="medium">
		<p>Zur Verwendung der Applikation muss ein Benutzername angelegt werden.</p>
	</ion-text>

	<form [formGroup]="uForm">
		<ion-item>
			<ion-label position="stacked">Benutzername</ion-label>
			<ion-input type="text" placeholder="Dein Benutzername" formControlName="username"></ion-input>
		</ion-item>

		<ion-button (click)="submit()" expand="block">Bestätigen</ion-button>
	</form>
</ion-content>
